import { Flame, Snowflake } from "lucide-react";
import type { LeadScore } from "@/lib/types";

const TONE: Record<LeadScore["faixa"], "warning" | "neutral" | "primary"> = {
  // "quente"/"frio" mapeados por analogia de temperatura (nao reusa
  // success/danger, que ja carregam "bom desfecho"/"bloqueado" no resto do
  // app — um lead quente nao fechou ainda, e um lead frio nao esta
  // bloqueado, so esfriou).
  quente: "warning",
  morno: "neutral",
  frio: "primary",
};

/** Mostra o score E os componentes que o formaram — nunca so o numero. E
 * heuristica declarada (pesos fixos, nao aprendida), e caixa preta numa
 * ferramenta de 2 pessoas so gera desconfianca (ver comentario da migration
 * v_lead_score). Expande com <details>: sem JS extra, acessivel por
 * teclado nativamente. */
export function ScoreBadge({ score }: { score: LeadScore | null | undefined }) {
  if (!score) return null;

  return (
    <details className="score-badge">
      <summary className={`badge badge--${TONE[score.faixa]}`}>
        {score.faixa === "quente" && <Flame className="icon" size={14} aria-hidden="true" />}
        {score.faixa === "frio" && <Snowflake className="icon" size={14} aria-hidden="true" />}
        Score {score.score} · {score.faixa}
      </summary>
      <div className="score-badge__detalhe">
        <p className="field-hint">
          Heurística declarada (pesos fixos revisados manualmente), não é previsão de IA.
        </p>
        {score.componentes.length === 0 ? (
          <p className="field-hint">Nenhum fator aplicado.</p>
        ) : (
          <ul>
            {score.componentes.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
        )}
      </div>
    </details>
  );
}
